

import { MwcSafeAny } from 'mwc/core/types';

export const statusColors = ['success', 'processing', 'error', 'default', 'warning'] as const;

export const presetColors = [
  'pink',
  'red',
  'yellow',
  'orange',
  'cyan',
  'green',
  'blue',
  'purple',
  'geekblue',
  'magenta',
  'volcano',
  'gold',
  'lime'
] as const;

export type MwcPresetColor = typeof presetColors[number];
export type MwcStatusColor = typeof statusColors[number];

export function isPresetColor(color: string): color is MwcPresetColor {
  return presetColors.indexOf(color as MwcSafeAny) !== -1;
}

export function isStatusColor(color: string): color is MwcPresetColor {
  return statusColors.indexOf(color as MwcSafeAny) !== -1;
}
